import type { MakeRequest } from "./types/MakeRequest";
import type { Options } from "./types/Options";

export const makePost =
  ({ makeRequest }: { makeRequest: MakeRequest }) =>
  (url: string, options: Options = {}) => {
    options.method = "post";
    options.headers = {
      "Content-Type": "application/json",
      ...options.headers,
    };

    return makeRequest(url, options);
  };
